module.exports = __webpack_public_path__ + "static/media/starbigr.d0467053.png";